export const LINE_SEPARATOR = '\u2028';
export const OBJECT_REPLACEMENT_CHARACTER = '\ufffc';
export const ZERO_WIDTH_NO_BREAK_SPACE = '\uFEFF';
